/* eslint-disable */
import { createSlice } from "@reduxjs/toolkit";
import { VEBPlanSchema } from "../../types/VEBPlanSchema";
import { fetchActiveVEBPlans } from "./VEBPlansThunks";

interface VEBPlansState {
	currentPlans: VEBPlanSchema[]; // <-- ARRAY
	futurePlans: VEBPlanSchema[]; // <-- ARRAY
	loading: boolean;
	error: string | null;
}

const initialState: VEBPlansState = {
	currentPlans: [],
	futurePlans: [],
	loading: false,
	error: null
};

const vebPlansSlice = createSlice({
	name: "vebPlans",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchActiveVEBPlans.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchActiveVEBPlans.fulfilled, (state, action) => {
				state.loading = false;
				state.currentPlans = action.payload.currentPlans || [];
				state.futurePlans = action.payload.futurePlans || [];
			})
			.addCase(fetchActiveVEBPlans.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || "Failed to fetch plans";
			});
	}
});

export default vebPlansSlice.reducer;
